"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransformFromLocalizedField = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const getTransformFromLocalizedField = (localizeFieldName) => ({ obj }) => {
    const localizedField = obj[localizeFieldName];
    return (0, utils_1.isUndefinedOrNull)(localizedField) ? "" : localizedField[legacy_enums_1.Languages.en] ? localizedField[legacy_enums_1.Languages.en] : "";
};
exports.getTransformFromLocalizedField = getTransformFromLocalizedField;
//# sourceMappingURL=getTransformFromLocalizedField.js.map